import { Box, Grid, ButtonGroup, Button, Typography } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useState, useEffect } from "react";
import ViewAllCardsCommon from "modules/MyContent/components/MyContentData/ViewAllCardsCommon";
import { CustomPaginationCommon } from "modules/Users/components";
import { useNavigate } from "react-router-dom";
import { useAppData } from "context/AppContext";

const ContentsData = () => {
  const [page, setPage] = useState(1); // One-based index for display
  const [itemsPerPage, setItemsPerPage] = useState(4); // Set items per page to 4
  const [filteredContents, setFilteredContents] = useState<any>([]); // New state for filtered contents
  const { contents, setSelectedType, selectedType } = useAppData();

  const navigation = useNavigate();

  const contentTypes = [
    { label: "View All", value: "ViewAll" },
    { label: "Handouts", value: "handout" },
    { label: "Courses", value: "course" },
  ];

  useEffect(() => {
    // Update filtered contents whenever contents or selectedType changes
    const newFilteredContents =
      selectedType === "ViewAll"
        ? contents
        : contents.filter((content) => content.type === selectedType);
    setFilteredContents(newFilteredContents);
  }, [contents, selectedType]);

  const handleTabChange = (tab: string) => {
    setSelectedType(tab);
    setPage(1);
  };

  const buttonStyles = (tab: string) => ({
    backgroundColor: selectedType === tab ? "#233F91" : "transparent",
    color: selectedType === tab ? "#fff" : "#000",
    borderColor: selectedType === tab ? "#233F91" : "#ccc",
    borderRadius: "20px",
    textTransform: "none",
    padding: "6px 16px",
    "&:hover": {
      backgroundColor: selectedType === tab ? "#233F91" : "transparent",
    },
  });

  const handleNavigateEditContent = (id: number) => {
    navigation(`/contents/edit/${id}`);
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    newPage: number
  ) => {
    setPage(newPage + 1); // Convert zero-based index to one-based for display
  };

  const getPaginatedData = (data: any[]) => {
    const startIndex = (page - 1) * itemsPerPage; // Correctly calculate start index
    return data.slice(startIndex, startIndex + itemsPerPage); // Use itemsPerPage for slicing
  };

  return (
    <Grid position={"relative"}>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        gap={3}
        px={5}
      >
        <Box
          pt={3}
          fontWeight={500}
          fontSize="28px"
          color="#233F91"
          display="flex"
          alignItems="center"
        >
          <KeyboardArrowLeftIcon sx={{ color: "#233F91", fontSize: "28px" }} />
          {"User’s"} Content
        </Box>
        <Box>
          <Box sx={styleSheet.optionsFullScreen}>
            {contentTypes.map((type, index) => (
              < >
                <Button
                  key={type.value}
                  onClick={() => handleTabChange(type.value)}
                  sx={buttonStyles(type.value)}
                >
                  {type.label}
                </Button>
                {index < contentTypes.length - 1 && (
                  <Box sx={styleSheet.rightBorder}></Box>
                )}
              </>
            ))}
          </Box>
        </Box>

        <Box mt={3}>
          <ViewAllCardsCommon
            data={getPaginatedData(filteredContents)}
            onEditContent={handleNavigateEditContent}
            titleColor="#233F91"
            cardBorderRadius="10px"
            buttonBackgroundColor="#1A73E8"
          />
        </Box>
      </Grid>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        <CustomPaginationCommon
          count={filteredContents.length} // Total number of items
          page={page - 1} // Convert to zero-based index for pagination component
          rowsPerPage={itemsPerPage} // Use itemsPerPage for rows per page
          onPageChange={handlePageChange}
        />
      </Box>
    </Grid>
  );
};

export default ContentsData;

const styleSheet = {
  addNewBtn: {
    borderRadius: "15px",
    width: "186px",
    height: "48px",
    textTransform: "none",
    backgroundColor: "#ffffff",
    border: "1px solid #233f91",
    color: "#233f91",
    fontSize: "15px",
    fontWeight: 700,
    display: { xs: "none", md: "flex" },
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  },
  addNewBtnMob: {
    borderRadius: "15px",
    width: "155px",
    // height: "48px",
    textTransform: "none",
    backgroundColor: "#ffffff",
    border: "1px solid #233f91",
    color: "#233f91",
    fontSize: "15px",
    fontWeight: 700,
    display: { xs: "flex", md: "none" },
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
  },
  optionsFullScreen: {
    display: { xs: "none", md: "flex" },
    gap: 1,
    alignItems: "center",
    border: "1px solid #BFBFBF",
    borderRadius: "20px",
    px: "2.84px",
    width: "299px",
    height: "39.2px",
    bgcolor: "#EDEDED",
  },
  rightBorder: {
    width: "1px",
    height: "17.03px",
    bgcolor: "#BFBFBF",
  },
  pagginationContainer: {
    display: "flex",
    justifyContent: "center",
    padding: "20px",
  },

  /// for mobile view

  optionsFullScreenMob: {
    display: { xs: "flex", md: "none" },
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "3px solid #BFBFBF",
    width: "360px",
    padding: "6px 0px",
  },
};
